import { CoPubliciteThumbnail } from '@/pages/collabs/co-publicites/CoPubliciteThumbnail';
import { Box, HStack, Link, Text } from '@chakra-ui/react';
import type { McpCopublicityReviewContent } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

/**
 * The creator and the post a co-publicity review would boost or stop, shown before its terms.
 * Each piece renders only when the backend could read it for the brand: a missing cover falls
 * back to the co-publicity placeholder tile, and a missing post address renders no link.
 */
export function McpCopublicityContent({ content }: { content: McpCopublicityReviewContent }) {
  const { t, i18n } = useTranslation();
  const handle = content.creatorHandle
    ? `@${content.creatorHandle}`
    : t('mcp.copublicity.unknownCreator');
  const postedAt = content.postedAt ? Date.parse(content.postedAt) : Number.NaN;
  const posted = Number.isFinite(postedAt)
    ? new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium' }).format(postedAt)
    : null;
  return (
    <HStack gap={3} align="center" borderWidth="1px" borderColor="border" rounded="md" p={3}>
      <CoPubliciteThumbnail thumbnailUrl={content.thumbnailUrl} username={handle} />
      <Box minW={0}>
        <Text fontWeight="semibold" overflowWrap="anywhere">
          {handle}
        </Text>
        {posted && (
          <Text color="fg.muted" fontSize="sm">
            {t('mcp.copublicity.postedOn', { date: posted })}
          </Text>
        )}
        {content.permalink && (
          <Link
            href={content.permalink}
            target="_blank"
            rel="noopener noreferrer"
            fontSize="sm"
            color="primary.400"
          >
            {t('mcp.copublicity.viewPost')}
          </Link>
        )}
      </Box>
    </HStack>
  );
}
